<template>
  <div class="_make-article ">
    <header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">ตอบกลับข้อความด้วยข้อความ (Message)</h1>
    </header>
    <div class="MarkdownContent">
      <p class="preindent">เป็น API ที่ใช้สำหรับการส่งข้อความ หาบุคคลอื่น โดยทำการกำหนดห้องแชทที่ต้องการส่งถึง ส่งได้ทั้งห้องแชทส่วนตัวและแชทกลุ่ม </p>
    </div>

    <header class="EndpointHeader">
      <h2 class="EndpointTitle">
        API ส่งข้อความ
      </h2>
      -
      <span class="EndpointVerbPost">
        POST
      </span>
      <span class="EndpointUrl">
        {{urlsendmsg}}
           <v-icon class="urlcopymessage" style="color:black; font-size: 13px !important; cursor: pointer;" v-clipboard:copy="urlsendmsg">file_copy</v-icon>
      </span>
    </header>

    <div class="MarkdownContent hidden-sm-and-down">
      <h3>Request Header</h3>
      <code class="codecolor">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
      <!-- <p class="preindent">ทุกครั้งที่ทำการติดต่อ API กับทางOneChat ต้องส่ง Authorization มาใน Header ทุกครั้ง </p> -->
      <h3>Request Parameter (JSON)</h3>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessage"
              v-clipboard:copy="message">
          <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
        </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"to"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ba521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"type"</span> : <span class="colorvalue">"text"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Hello world!!"</span>,
    <span class="colorkey">"custom_notification"</span> : <span class="colorvalue">"เปิดอ่านข้อความใหม่จากทางเรา"</span>
  }
      </code>

    <!-- <h3>รายละเอียดข้อมูลที่ใช้ในการส่งข้อความ</h3> -->
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>จำเป็น (Required)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>to</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>user_id หรือ group_id ที่ต้องการจะส่ง</td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        <tr>
          <td>type</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>ประเภทของข้อความ ในที่นี้เป็น text</td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>ข้อความที่ต้องการส่ง</td>
        </tr>
        <tr>
          <td>custom_notification</td>
          <td>String</td>
          <td></td>
          <td>ข้อมูลสำหรับแสดงการแจ้งเตือน</td>
        </tr>
      </table>


      <!-- <h3>Response กรณีที่ส่ง request มาถูกต้อง  - </h3> -->
<!-- 200OK -->
      <!-- กรณีที่ส่ง request มาถูกต้อง  -  -->
<!--       <span class="EndpointVerbPost">
        200 OK
      </span> -->
      <br>
       <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerbPost">
        200 OK
      </span>
      <span class="EndpointUrl">
        กรณีที่ส่ง request มาถูกต้อง
      </span>
    </header>
<code class="codecolor">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messageresponse">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"message"</span> : {
      <span class="colorkey">"id"</span> : <span class="colorvalue">"5b861xxxxxc6f9026xxxxxxx"</span>,
      <span class="colorkey">"text"</span> : <span class="colorvalue">"Hello world!!"</span>,
      <span class="colorkey">"type"</span> : <span class="colorvalue">"text"</span>
    },
    <span class="colorkey">"timestamp"</span> : <span class="colorvalue">1538985275000</span>,
    <span class="colorkey">"type_source"</span> : <span class="colorvalue">"bot"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ba521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"type_destination"</span> : <span class="colorvalue">"user"</span>,
    <span class="colorkey">"user_id"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>
  }
</code>

<!-- <h3>รายละเอียดข้อมูลที่ได้จากการส่งข้อความ</h3> -->
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>message</td>
          <td>Dictionary (json)</td>
          <td>ข้อมูลทั้งหมด ที่เกี่ยวกับข้อความนั้น ๆ ประกอบด้วย<br>
            <ul>
            <li>id คือ เลขเฉพาะที่บ่งบอกถึงข้อความนั้นๆ</li>
            <li>text คือ ข้อความที่ถูกส่ง</li>
            <li>type คือ ประเภทข้อความที่ถูกส่ง ในที่นี้เป็น "text"</li>
          </ul>
          </td>
        </tr>
        <tr>
          <td>timestamp</td>
          <td>Integer</td>
          <td>วันและเวลาที่ส่งข้อความ</td>
        </tr>
        <tr>
          <td>type_source</td>
          <td>String</td>
          <td>ประเภทของบุลคลที่ส่งข้อความ ในที่นี้เป็น bot</td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        <tr>
          <td>type_destination</td>
          <td>String</td>
          <td>ประเภทของห้องแชทที่ส่ง ซึ่งจะเป็น user หรือ group</td>
        </tr>
        <tr>
          <td>user_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของบุคคลที่ส่งข้อความ</td>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>success แสดงว่าการทำงานใน API นั้นสำเร็จ
          </td>
        </tr>
      </table>

      <!-- 401 Authorization fail -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerberror">401 UNAUTHORIZED</span>
        <span class="EndpointUrl">กรณีที่ส่ง Authorization มาผิด</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageauthoerror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Authorization fail."</span>
  }
      </code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Authorization fail."</td>
        </tr>

      </table>

<!-- 404  -->
      <!-- tokenroom ผิด -->
<br>




      <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerbfail">
       404 NOT FOUND
      </span>
      <span class="EndpointUrl">
        กรณีที่ส่ง to มาผิด
      </span>
    </header>
<code class="codecolor">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messagetokenroomerror">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"User ID not found."</span>
  }
</code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด <br>
            <ul>
            <li>"User ID not found."</li>
            <li>"Group ID not found."</li>
          </ul>
          </td>
        </tr>
      </table>
      <!-- token bot -->
      <br>


  <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerbfail">
       404 NOT FOUND
      </span>
      <span class="EndpointUrl">
        กรณีที่ส่ง bot_id มาผิด
      </span>
    </header>
<code class="codecolor">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messageboterror">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Bot ID not found."</span>
  }
</code>

<!-- <h3>รายละเอียดข้อมูลที่ได้จากการส่งข้อความ</h3> -->
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Bot ID not found."
          </td>
        </tr>
      </table>

 <!-- type ผิด -->
<br>
            <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerbfail">
       404 NOT FOUND
      </span>
      <span class="EndpointUrl">
        กรณีที่ส่ง type มาผิด

      </span>
    </header>
<code class="codecolor">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messagetypeerror">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Type not support."</span>
  }
</code>

<!-- <h3>รายละเอียดข้อมูลที่ได้จากการส่งข้อความ</h3> -->
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
         <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Type not support."
          </td>
        </tr>
      </table>
      <!-- 400 -->
<br>
  <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerberror">
       400 BAD REQUEST
      </span>
      <span class="EndpointUrl">
        กรณีที่ส่ง พารามิเตอร์ มาผิด

      </span>
    </header>
<code class="codecolor">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messageparametererror">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Parameter error."</span>
  }
</code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Parameter error."
          </td>
        </tr>
      </table>

       <!-- 400 value message -->
<br>
  <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerberror">
       400 BAD REQUEST
      </span>
      <span class="EndpointUrl">
        กรณีที่ค่าmessage ไม่เป็นstring

      </span>
    </header>
<code class="codecolor">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messagenotstring">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Value of message not support."</span>
  }
</code>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Value of message not support."
          </td>
        </tr>
      </table>



    </div>
    <!-- mobile -->
    <div class="hidden-md-and-up">
      <h3>Request Header</h3>
      <code class="codecolormo">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
      <h3>Request Parameter (JSON)</h3>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessage"
              v-clipboard:copy="message">
          <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
        </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"to"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ba521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"type"</span> : <span class="colorvalue">"text"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Hello world!!"</span>,
    <span class="colorkey">"custom_notification"</span> : <span class="colorvalue">"เปิดอ่านข้อความใหม่จากทางเรา"</span>
  }
      </code>

    <!-- <h3>รายละเอียดข้อมูลที่ใช้ในการส่งข้อความ</h3> -->
     <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>จำเป็น (Required)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>to</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>user_id หรือ group_id ที่ต้องการจะส่ง</td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        <tr>
          <td>type</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>ประเภทของข้อความ ในที่นี้เป็น text</td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td style="text-align: center;">✅</td>
          <td>ข้อความที่ต้องการส่ง</td>
        </tr>
        <tr>
          <td>custom_notification</td>
          <td>String</td>
          <td></td>
          <td>ข้อมูลสำหรับแสดงการแจ้งเตือน</td>
        </tr>
      </table>
      <br>

       <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerbPost">
        200 OK
      </span>
      <span class="EndpointUrl">
        กรณีที่ส่ง request มาถูกต้อง

      </span>
    </header>
<code class="codecolormo">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messageresponse">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
 {
    <span class="colorkey">"message"</span> : {
      <span class="colorkey">"id"</span> : <span class="colorvalue">"5b861xxxxxc6f9026xxxxxxx"</span>,
      <span class="colorkey">"text"</span> : <span class="colorvalue">"Hello world!!"</span>,
      <span class="colorkey">"type"</span> : <span class="colorvalue">"text"</span>
    },
    <span class="colorkey">"timestamp"</span> : <span class="colorvalue">1538985275000</span>,
    <span class="colorkey">"type_source"</span> : <span class="colorvalue">"bot"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ba521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"type_destination"</span> : <span class="colorvalue">"user"</span>,
    <span class="colorkey">"user_id"</span> : <span class="colorvalue">"U5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>
  }
</code>

<!-- <h3>รายละเอียดข้อมูลที่ได้จากการส่งข้อความ</h3> -->
      <table id="apimsgtablemo" style="margin-top: 2vh;">
      <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>message</td>
          <td>Dictionary (json)</td>
          <td>ข้อมูลทั้งหมด ที่เกี่ยวกับข้อความนั้น ๆ ประกอบด้วย<br>
            <ul>
            <li>id คือ เลขเฉพาะที่บ่งบอกถึงข้อความนั้นๆ</li>
            <li>text คือ ข้อความที่ถูกส่ง</li>
            <li>type คือ ประเภทข้อความที่ถูกส่ง ในที่นี้เป็น "text"</li>
          </ul>
          </td>
        </tr>
        <tr>
          <td>timestamp</td>
          <td>Integer</td>
          <td>วันและเวลาที่ส่งข้อความ</td>
        </tr>
        <tr>
          <td>type_source</td>
          <td>String</td>
          <td>ประเภทของบุลคลที่ส่งข้อความ ในที่นี้เป็น bot</td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        <tr>
          <td>type_destination</td>
          <td>String</td>
          <td>ประเภทของห้องแชทที่ส่ง ซึ่งจะเป็น user หรือ group</td>
        </tr>
        <tr>
          <td>user_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของบุคคลที่ส่งข้อความ</td>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>success แสดงว่าการทำงานใน API นั้นสำเร็จ
          </td>
        </tr>
      </table>
      <!-- 401 Authorization fail -->
      <br>
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerberror">401 UNAUTHORIZED</span>
        <span class="EndpointUrl">กรณีที่ส่ง Authorization มาผิด</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageauthoerror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
        {
          <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
          <span class="colorkey">"message"</span> : <span class="colorvalue">"Authorization fail."</span>
        }
      </code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Authorization fail."</td>
        </tr>


      </table>
<!-- 404  -->
      <!-- token bot -->
      <br>

  <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerbfail">
       404 NOT FOUND
      </span>
      <span class="EndpointUrl">
        กรณีที่ส่ง bot_id มาผิด

      </span>
    </header>
<code class="codecolormo">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messageboterror">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Bot ID not found."</span>
  }
</code>

<!-- <h3>รายละเอียดข้อมูลที่ได้จากการส่งข้อความ</h3> -->
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Bot ID not found."
          </td>
        </tr>
      </table>
      <!-- tokenroom ผิด -->
<br>

      <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerbfail">
       404 NOT FOUND
      </span>
      <span class="EndpointUrl">
        กรณีที่ส่ง to มาผิด

      </span>
    </header>
<code class="codecolormo">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messagetokenroomerror">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>
    <span class="colorkey">"message"</span> : <span class="colorvalue">"User ID not found."</span>
  }
</code>

<!-- <h3>รายละเอียดข้อมูลที่ได้จากการส่งข้อความ</h3> -->
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด <br>
            <ul>
              <li>"User ID not found."</li>
              <li>"Group ID not found."</li></ul>
          </td>
        </tr>
      </table>
 <!-- tokenroom ผิด -->
<br>
            <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerbfail">
       404 NOT FOUND
      </span>
      <span class="EndpointUrl">
        กรณีที่ส่ง type มาผิด

      </span>
    </header>
<code class="codecolormo">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messagetypeerror">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Type not support."</span>
  }
</code>

<!-- <h3>รายละเอียดข้อมูลที่ได้จากการส่งข้อความ</h3> -->
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Type not support."
          </td>
        </tr>
      </table>
      <!-- 400 -->
<br>
  <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerberror">
       400 BAD REQUEST
      </span>
      <span class="EndpointUrl">
        กรณีที่ส่ง พารามิเตอร์ มาผิด

      </span>
    </header>
<code class="codecolormo">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messageparametererror">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Parameter error."</span>
  }
</code>

<!-- <h3>รายละเอียดข้อมูลที่ได้จากการส่งข้อความ</h3> -->
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Parameter error."
          </td>
        </tr>
      </table>


       <!-- 400 value message -->
<br>
  <header class="EndpointHeader">
<h2 class="EndpointTitle">
        Response (JSON)
      </h2>
      -
      <span class="EndpointVerberror">
       400 BAD REQUEST
      </span>
      <span class="EndpointUrl">
        กรณีที่ค่าmessage ไม่เป็นstring

      </span>
    </header>
<code class="codecolormo">
  <v-tooltip top>
<v-btn flat icon type="button" style="float: right;"
slot="activator" class="requestmessageresponse"
      v-clipboard:copy="messagenotstring">
      <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Value of message not support."</span>
  }
</code>
      <table id="apimsgtablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Value of message not support."
          </td>
        </tr>
      </table>
  </div>
</div>
<!-- </section> -->
<!--
</div>
</div>
</div> -->
</template>

<script>
import Navbar from '@/components/home/Navbar'
export default {
  components: {
    Navbar
  },
  data: () => ({
    urlsendmsg: '',
    message: '{\n\t"to": "U5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t"bot_id": "Ba521xx18350a5xxx2bxxxxx",\n\t"type": "text",\n\t"message": "Hello world!!",\n\t"custom_notification": "เปิดอ่านข้อความใหม่จากทางเรา"\n}',
    messageresponse: '{\n\t"message": {\n\t\t"id": "5b861xxxxxc6f9026xxxxxxx",\n\t\t"text": "Hello world!!",\n\t\t"type": "text"\n\t},\n\t"timestamp": 1538985275000,\n\t"type_source": "bot",\n\t"bot_id": "Ba521xx18350a5xxx2bxxxxx",\n\t"type_destination": "user",\n\t"user_id": "U5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t"status": "success"\n}',
    messagetokenroomerror: '{\n\t"status": "fail",\n\t"message": "User ID not found."\n}',
    messageboterror: '{\n\t"status": "fail",\n\t"message": "Bot ID not found."\n}',
    messagetypeerror: '{\n\t"status": "fail",\n\t"message": "Type not support."\n}',
    messageparametererror: '{\n\t"status": "fail",\n\t"message": "Parameter error."\n}',
    messageauthoerror: '{\n\t"status": "fail",\n\t"message": "Authorization fail."\n}',
    messagenotstring: '{\n\t"status": "fail",\n\t"message": "Value of message not support."\n}',
    headermessage: '{\n\t"header": "Bearer 0nTblsxxx"}'
  }),
  methods: {

  },
  created () {
    this.urlsendmsg = process.env.APIimage + '/api/v1/push_message'
  }
}
</script>

<style type="text/css" scoped>
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 100%;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbfail {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid orange;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: orange;
    color: #FFFFFF;
}
.EndpointVerberror {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid red;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: red;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
}
#apimsgtable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apimsgtable td, #apimsgtable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtable tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtable tr:hover {background-color: #ddd;}

#apimsgtable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}

#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
.requestmessage {
    display: none !important;
}

.codecolor:hover .requestmessage {
    display: block !important;
}

.urlcopymessage {

    display: none !important;
}
.EndpointUrl:hover .urlcopymessage {
    display: inline !important;
}
.requestmessageresponse{
    display: none !important;
}

.codecolor:hover .requestmessageresponse {
    display: block !important;
}


</style>





// WEBPACK FOOTER //
// src/components/home/api/reply/webhook_replymsg.vue